import { ENGLISH_ONLY_BADGE_ARIA_LABEL, ENGLISH_ONLY_BADGE_TEXT } from "utilities/Constant";
import { GLOBAL_LINK_NO_TX_CLASS } from "utilities/globalLinkNoTx";
import "./EnglishOnlyBadge.scss";

export default function EnglishOnlyBadge() {
  return (
    <span className={`english-only-badge ${GLOBAL_LINK_NO_TX_CLASS}`} aria-label={ENGLISH_ONLY_BADGE_ARIA_LABEL}>
      {ENGLISH_ONLY_BADGE_TEXT}
    </span>
  );
}
